import React, { useMemo, useState } from 'react';
import AnalysisView from '../../../component/AnalysisView';
import {
  PromptConfirmItemType,
  PromptListType,
} from '@op/components/GPT/types';
import { Row, Col } from 'tea-component';
import AnalysisTable from '../../../component/AnalysisTable';
import { useIntl } from 'umi';
import UrlMetricsCard from '../../../component/UrlMetricsCard';
import { GPTContentType, PromptKeyType } from '../../../types';
import GPTContentInfo from './GPTContentInfo';
import UrlLoadingCard from './UrlLoadingCard';

type URLCardProps = {
  filter: any;
  gameInfo: any;
  wholeGameInfo: any;
  loading: boolean;
  isPreviews: boolean;
  promptList: PromptListType;
  setApiLoading?: (flag: string) => void;
  promptInfoMap: any;
  setPromptInfo: (
    value: PromptConfirmItemType,
    key: PromptKeyType,
    paramsKey: 'video_task_id' | 'comment_task_id',
  ) => Promise<boolean>;
  oriFilterValue: any;
  gptList: GPTContentType[];
  gptListRef: { current: GPTContentType[] }
  taskId?: number;
  setLoading: (flag: boolean) => void;
  handleStop: () => void;
  saveTipsElement: any;
  videoPromptList: PromptListType;
  taskData?: any;
};

export default function URLCard(props: URLCardProps) {
  if (props.loading || !props.filter) return null;

  return <UrlBody {...props}></UrlBody>;
}

function UrlBody({
  filter,
  gameInfo,
  wholeGameInfo,
  loading,
  saveTipsElement,
  isPreviews,
  promptList,
  setApiLoading,
  promptInfoMap,
  setPromptInfo,
  oriFilterValue,
  gptList,
  gptListRef,
  taskId,
  setLoading,
  handleStop,
  videoPromptList,
  taskData,
}: URLCardProps) {
  const { formatMessage } = useIntl();
  const [showCheckbox, setShowCheckbox] = useState(false);
  const [checked, setChecked] = useState(false);
  const [allCommentsFilter, setAllCommentsFilter] = useState({});

  const { realFilter, tableFilter } = useMemo(() => {
    if (!filter) return { realFilter: null, tableFilter: null };
    const {
      comments_prompt,
      comments_task_type,
      need_summary,
      video_task_type,
      video_prompt,
      model_type,
      ...otherFilter
    } = filter || {};

    if (checked) {
      return {
        realFilter: { ...otherFilter, ...(allCommentsFilter || {}) },
        tableFilter: { ...otherFilter, feed_source: 'url', ...(allCommentsFilter || {}) },
      };
    }

    return {
      realFilter: otherFilter,
      tableFilter: { ...otherFilter, feed_source: 'url' },
    };
  }, [filter, checked]);

  return (
    <UrlLoadingCard
      filter={realFilter}
      taskId={taskId}
      isPreviews={isPreviews}
      setLoading={setLoading}
      gameInfo={gameInfo}
      handleStop={handleStop}
      saveTipsElement={saveTipsElement}
      taskData={taskData}
      gptList={gptListRef}
      setAllCommentsFilter={setAllCommentsFilter}
      setShowCheckbox={setShowCheckbox}
    >
      {({ isSingleUrl, gptTaskList, percentList }) => {
        return (
          <AnalysisView
            filter={realFilter}
            tab="url"
            wholeGameInfo={wholeGameInfo}
            filterLoading={loading}
            gameInfo={gameInfo}
            isSingleUrl={isSingleUrl}
            isPreviews={isPreviews}
            percentList={percentList}
            checked={checked}
            setChecked={setChecked}
            showCheckbox={showCheckbox}
          >
            <UrlMetricsCard
              isSingleUrl={isSingleUrl}
              filter={realFilter}
              gameInfo={gameInfo}
              setApiLoading={setApiLoading}
            ></UrlMetricsCard>

            <GPTContentInfo
              gptList={gptList}
              gptTaskList={gptTaskList}
              filter={realFilter}
              promptList={promptList}
              videoPromptList={videoPromptList}
              isPreviews={isPreviews}
              promptInfoMap={promptInfoMap}
              setPromptInfo={setPromptInfo}
              saveTipsElement={saveTipsElement}
              setApiLoading={setApiLoading}
            ></GPTContentInfo>

            <Row className="dbo-aigc-card-wrapper dbo-analysis-card-container dbo-aigc-card-wrapper--comments">
              <Col span={24}>
                <AnalysisTable
                  tab={'total'}
                  title={formatMessage({ id: 'Comments' })}
                  hasTitleArrow={false}
                  hasTabChange={false}
                  filter={tableFilter}
                  oriFilterValue={oriFilterValue}
                  gameInfo={gameInfo}
                  wholeGameInfo={wholeGameInfo}
                  setApiLoading={setApiLoading}
                  detailParams={{ feed_source: 'url' }}
                  handleTitleOnClick={() => { }}
                />
              </Col>
            </Row>
          </AnalysisView>
        );
      }}
    </UrlLoadingCard>
  );
}
